import { css } from '@emotion/react';

import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    container: css({
        width: '100%',
        paddingInline: '20px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderBottom: `1px solid ${theme.palette.grey[600]}`,
        position: 'sticky',
        top: 0,
        left: 0,
        zIndex: 1000,
        height: '50px',
        background: isHosTheme ? theme.palette.common.black : theme.palette.common.white,
        [theme.breakpoints.up('lg')]: {
            paddingInline: '60px',
        },
    }),
    rightSide: css({
        display: 'flex',
        gap: '20px',
        alignItems: 'center',
        textDecoration: 'underline',
        [theme.breakpoints.down('sm')]: {
            gap: '0',
        },
    }),
    logoMobile: css({
        display: 'block',
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
    }),
    logoDesktop: css({
        display: 'none',
        [theme.breakpoints.up('lg')]: {
            display: 'block',
        },
    }),
    langDropdown: css({
        background: 'red',
        border: '1px solid blue',
    }),
    koko: css({
        cursor: 'default',
        display: 'flex',
        border: 'none !important',

        '.MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            minHeight: '40px !important',
            paddingBottom: '0 !important',
            paddingTop: '0 !important',

            '.LangSwitcher__country-name': {
                display: 'none',
            },

            '&[aria-expanded="true"] ~ .MuiSelect-custom-arrow-component': {
                transform: 'rotate(180deg)',
            },
        },
    }),
    loginText: css({
        cursor: 'pointer',
        color: isHosTheme
            ? `${theme.palette.common.white} !important`
            : `${theme.palette.common.black} !important`,
    }),
};
